import { render, staticRenderFns } from "./AwsAcctList.vue?vue&type=template&id=204a4866&scoped=true&"
import script from "./AwsAcctList.vue?vue&type=script&lang=js&"
export * from "./AwsAcctList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204a4866",
  null
  
)

export default component.exports